<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->

            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-credit-card"></i> My Reports</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard/expenses']"><i class="fa fa-arrow-left"> Back</i></button>
                </div>
            </div>
            
          
            <div class="row row-replace m-t-30">
                <div class="col-12">
                    <p class="text-danger"> <i class="fa fa-list"></i> My Reports (Note : it is not right table)</p>
                       <div class="table-responsive">
                           <table class="table">
                               <tr class="bg-primary text-white">

                                  <th>
                                    <span><input type="checkbox"></span>
                                    <span class="ml-10">ID</span>
                                  </th>
                                  <th>Date</th>
                                  <th>Category</th>
                                  <th>Merchant</th>
                                  <th>Report</th>
                                  <th>Status</th>
                                  <th><i class="fa fa-inr"></i> Amount</th>
                               </tr>
                               <tr>
                                <th>
                                    <span><input type="checkbox"></span>
                                    <span class="ml-10">1</span>
                                  </th>
                                  <td>27/02/2021</td>
                                  <td>Mobile Expense</td>
                                  <td></td>
                                  <td>Exense Report</td>
                                  <td>Approved</td>
                                  <td>3254</td>
                               </tr>
                           </table>
                        </div>
                   </div>
            </div>

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

